// Soft watch-tick — loads the uploaded MP3 once as an AudioBuffer, then plays
// only a single short tick (≈140 ms) on each call, regardless of the source
// file's full length.

const TICK_URL =
  "https://customer-assets.emergentagent.com/job_portfolio-hub-2121/artifacts/w3ppfaam_tick%202%20sound.m4a";

// Play the full uploaded clip (it's already a single short tick)
const TICK_DURATION = null;

let ctx = null;
let buffer = null;
let loading = null;
let unlocked = false;

const getCtx = () => {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  return ctx;
};

const loadBuffer = () => {
  if (buffer || loading) return loading;
  const c = getCtx();
  if (!c) return null;
  loading = fetch(TICK_URL)
    .then((r) => r.arrayBuffer())
    .then((data) => c.decodeAudioData(data))
    .then((decoded) => {
      buffer = decoded;
    })
    .catch(() => {
      /* swallow */
    });
  return loading;
};

export const initTickAudio = () => {
  if (typeof window === "undefined") return;
  loadBuffer();
  if (unlocked) return;
  const unlock = () => {
    const c = getCtx();
    if (c && c.state === "suspended") c.resume().catch(() => {});
    unlocked = true;
    window.removeEventListener("pointerdown", unlock);
    window.removeEventListener("keydown", unlock);
    window.removeEventListener("touchstart", unlock);
  };
  window.addEventListener("pointerdown", unlock, { once: true });
  window.addEventListener("keydown", unlock, { once: true });
  window.addEventListener("touchstart", unlock, { once: true });
};

export const playTick = (volume = 0.595) => {
  const c = getCtx();
  if (!c) return;
  if (c.state === "suspended") c.resume().catch(() => {});
  if (!buffer) {
    // Buffer not ready yet; trigger a load and bail silently
    loadBuffer();
    return;
  }
  const now = c.currentTime;
  const src = c.createBufferSource();
  src.buffer = buffer;
  const gain = c.createGain();
  gain.gain.setValueAtTime(volume, now);
  src.connect(gain).connect(c.destination);
  if (TICK_DURATION) {
    gain.gain.setValueAtTime(volume, now + TICK_DURATION - 0.02);
    gain.gain.linearRampToValueAtTime(0, now + TICK_DURATION);
    src.start(now, 0, TICK_DURATION);
  } else {
    src.start(now);
  }
};
